import { ProtectedImage } from "./ProtectedImage";

// A feed image must belong to its announcement; the shared component retrieves and releases it.
export function AnnouncementImage({ announcement }) {
  const id = announcement?.content_id;
  const image = announcement?.image;
  if (typeof id !== "string" || !/^[a-f0-9]{24}$/.test(id) || !image || typeof image !== "object" || Array.isArray(image)) return null;
  if (image.href !== `/api/member/content/${id}/media` || !["image/png", "image/jpeg", "image/webp"].includes(image.mime)) return null;
  if (typeof image.alt !== "string" || !image.alt.trim()) return null;
  return <ProtectedImage raw={image} testid="announcement-image" />;
}
